<template>
    <main>
        <ai-feedback :user-input="userInput" />
    </main>
</template>

<script lang="ts">
import Vue from 'vue';
import AiFeedback from '@/components/AiFeedback.vue';
import nProgress from 'nprogress';
import { unfoldError } from '@/common/js/notice';

export default Vue.extend({
    components: {
        AiFeedback
    },
    computed:{
        userInput(): object {

            const rawUserInput = this.$route.query.userInput;
            if ( typeof rawUserInput === 'string' ) {

                try {

                    return JSON.parse(  rawUserInput );

                } catch ( e ) {

                    console.error( 'Failed to parse userInput:', e );
                    unfoldError( 'errors.invalid_device_found' );

                }

            }

            return {};

        }
    },
    mounted() {

        nProgress.done();

    },
});
</script>

<style lang="less" scoped>
main{
    display: flex;
    justify-content: center;
    min-height: calc(100vh + 200px);
    background-color: @bg_02;
}
</style>
